// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.matchmaking-loading_wrapper__KODhW {
  padding: 24px;
  display: grid;
  grid-template-rows: min-content 1fr min-content;
  gap: 24px;
  border-radius: 6px;
}

.matchmaking-loading_header__ZiY5R {
  display: grid;
  grid-template-rows: repeat(3, min-content);
  gap: 12px;
}

.matchmaking-loading_step__3h15X {
  font-size: 20px;
  font-weight: 800;
  display: flex;
  justify-content: center;
}

.matchmaking-loading_form__BfnPM {
  display: grid;
  grid-template-rows: repeat(3, min-content);
  gap: 24px;
}

.matchmaking-loading_blue__FUxXl {
  color: var(--start-actions-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/empty-state/steps/matchmaking-loading.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":[".wrapper {\n  padding: 24px;\n  display: grid;\n  grid-template-rows: min-content 1fr min-content;\n  gap: 24px;\n  border-radius: 6px;\n}\n\n.header {\n  display: grid;\n  grid-template-rows: repeat(3, min-content);\n  gap: 12px;\n}\n\n.step {\n  font-size: 20px;\n  font-weight: 800;\n  display: flex;\n  justify-content: center;\n}\n\n.form {\n  display: grid;\n  grid-template-rows: repeat(3, min-content);\n  gap: 24px;\n}\n\n.blue {\n  color: var(--start-actions-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `matchmaking-loading_wrapper__KODhW`,
	"header": `matchmaking-loading_header__ZiY5R`,
	"step": `matchmaking-loading_step__3h15X`,
	"form": `matchmaking-loading_form__BfnPM`,
	"blue": `matchmaking-loading_blue__FUxXl`
};
export default ___CSS_LOADER_EXPORT___;
